import { render, staticRenderFns } from "./FilePdfIcon.vue?vue&type=template&id=46593a91&"
import script from "./FilePdfIcon.vue?vue&type=script&lang=js&"
export * from "./FilePdfIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports